const asset = (name:string) => `/assets/sfx/${name}`;
const dartSources = Array.from({ length:8 }, (_, index) => asset(`dart-hit-${index + 1}.wav`));

let prepared = false;
let shuffleAudio:HTMLAudioElement|null = null;
let pickPool:HTMLAudioElement[] = [];
let flipPool:HTMLAudioElement[] = [];
let dartPool:HTMLAudioElement[] = [];
let dartPreloads:HTMLAudioElement[] = [];
let pickIndex = 0;
let flipIndex = 0;
let dartIndex = 0;

function makeAudio(source:string, volume:number, loop = false) {
  const audio = new Audio(source);
  audio.preload = "auto";
  audio.volume = volume;
  audio.loop = loop;
  audio.load();
  return audio;
}

export function preloadInteractionSounds() {
  if (prepared || typeof Audio === "undefined") return;
  prepared = true;
  shuffleAudio = makeAudio(asset("shuffle-loop.wav"), 0.52, true);
  pickPool = [makeAudio(asset("card-pick.wav"), 0.72), makeAudio(asset("card-pick.wav"), 0.72)];
  flipPool = [makeAudio(asset("card-flip.wav"), 0.72), makeAudio(asset("card-flip.wav"), 0.72)];
  dartPreloads = dartSources.map((source) => makeAudio(source, 0.01));
  dartPool = [makeAudio(dartSources[0], 0.95), makeAudio(dartSources[1], 0.95)];
}

function playFromPool(pool:HTMLAudioElement[], index:number) {
  const audio = pool[index % pool.length];
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
  void audio.play().catch(() => { /* 视觉反馈仍然可用 */ });
}

export function startShuffleSound() {
  preloadInteractionSounds();
  if (!shuffleAudio) return () => undefined;
  shuffleAudio.currentTime = 0;
  void shuffleAudio.play().catch(() => { /* 用户下一次点击会再次触发 */ });
  return () => {
    shuffleAudio?.pause();
    if (shuffleAudio) shuffleAudio.currentTime = 0;
  };
}

export function playCardPickSound() {
  preloadInteractionSounds();
  playFromPool(pickPool, pickIndex++);
}

export function playCardFlipSound() {
  preloadInteractionSounds();
  playFromPool(flipPool, flipIndex++);
}

export function playDartHitSound(variant:number) {
  preloadInteractionSounds();
  const channel = dartPool[dartIndex++ % 2];
  if (!channel) return;
  const source = dartPreloads[variant % dartPreloads.length]?.src || dartSources[variant % dartSources.length];
  channel.pause();
  channel.src = source;
  channel.currentTime = 0;
  void channel.play().catch(() => { /* 手机震动、爆点和回弹仍然执行 */ });
}

export const dartHitLabels = ["啊！", "哎呀！", "疼疼疼！", "轻点轻点！", "我知道错了！", "大人饶命！", "别扎了，我改！", "都是我的问题！"];
